<template>
  <v-form ref="formReservation" v-model="validForm" lazy-validation>
    <span class="title-user-scr">Solicitud de reservación</span>
    <div class="title-user-scr">{{ booking.title }}</div>
    <v-text-field :rules="[rules.required]" v-model="title" label="Evento a realizar"></v-text-field>

    <v-col sm="6">
      <label for="date"
        ><DatePicker
          :min="min"
          :initialDate="min"
          label="Fecha de reservación"
          name="date"
          @change="reservationDate = $event"
      /></label>
    </v-col>
    <v-row class="d-flex align-center mb-6">
      <v-col sm="6">
        <time-picker
          label="Hora de reservación"
          :rules="[rules.required]"
          :initialHour="reservationHour"
          :min="timeStart"
          :max="timeEnd"
          @change="reservationHour = $event"
        ></time-picker>
      </v-col>
      <v-col sm="6">
        <div>Finaliza: {{ finaliza }}</div>
      </v-col>
    </v-row>

    <v-textarea
      :rules="[rules.required]"
      v-model="description"
      label="Mensaje adicional"
      outlined
      name="input-7-4"
    ></v-textarea>
    <v-btn block color="primary" large rounded link @click="request" style="margin-top: 25px">Enviar solicitud</v-btn>
  </v-form>
</template>



<script>
import reservationService from '@/services/users/reservations';

import { mapGetters } from 'vuex';

import DatePicker from '@/components/DatePicker.vue';
import TimePicker from '@/components/TimePicker2.vue';
export default {
  components: {
    DatePicker,
    TimePicker,
  },
  data() {
    return {
      validForm: true,
      menu1: false,
      title: '',
      description: '',
      reservationHour: 7,
      timeStart: 7,
      timeEnd: 22,
      reservationDate: this.$dayjs(Date.now()).add(1, 'd').format('YYYY-MM-DD'),
      min: () => this.$dayjs(Date.now()).add(this.booking.dias_min_reserva, 'd').format('YYYY-MM-DD'),     
      rules: {
        min: (value) =>
          value >= this.$settingBlockSize || 'La duración debe ser mayor a ' + this.$settingBlockSize + ' horas',
        max: (value) => value <= 23 || 'La duración debe ser menor a 24 horas',
        required: (value) => !!value || 'Required.',
      },
    };
  },
  created() {
    this.timeStart = this.booking.timeStart;
    this.timeEnd = this.getTimeEnd();
    this.reservationHour = this.timePickerToNum(this.booking.timeStart);  
  //  this.min = this.$dayjs(Date.now()).add(this.booking.dias_min_reserva, 'd').format('YYYY-MM-DD');
    this.min = this.$dayjs().startOf('day').add(this.booking.dias_min_reserva, 'day').format('YYYY-MM-DD');
    this.reservationDate = this.$dayjs().startOf('day').add(this.booking.dias_min_reserva, 'day').format('YYYY-MM-DD');
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    ...mapGetters({
      booking: 'room/currentRoom',
      settings: 'settings',
      user: 'session/user',
    }),  
    finaliza(){
      return this.calcEndHour(this.reservationHour);
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },  
  },
  methods: {   
    getTimeEnd(){ // getTimeEnd es la hora maxima que permite reservar timeEnd - lapse
      const { timeEnd, lapse, nextDay } = this.booking;

      if (!timeEnd || typeof timeEnd !== 'string') return null;

      const [endHour, endMin] = timeEnd.split(':').map(Number);

      // Convert to total minutes and adjust with lapse (in hours)
      let totalMinutes = (nextDay ? 24 * 60 : 0) + endHour * 60 + endMin - lapse * 60;

      // Normalize to 0–1439 minutes
      totalMinutes = ((totalMinutes % (24 * 60)) + (24 * 60)) % (24 * 60);

      const correctedHour = Math.floor(totalMinutes / 60);
      const correctedMin = totalMinutes % 60;

      const hourStr = String(correctedHour).padStart(2, '0');
      const minStr = String(correctedMin).padStart(2, '0');

      return `${hourStr}:${minStr}:00`;
    },
    calcEndHour(start) {    
      if (!start) return null;
      let lapse = this.booking.lapse;      

      let endHour = 0;
      const startHour = this.timePickerToNum(start);
      endHour = Number(startHour) + Number(lapse);
      if (this.booking.nextDay) {
          endHour = (Number(startHour) + Number(lapse)) % 24;
        }      
     const formattedHour = endHour.toString().padStart(2, '0');
     return `${formattedHour}:00 Hrs`;
    },

    timePickerToNum (hora) {      
      if (typeof hora === 'string') {
        return hora.split(':').map(Number)[0];       
      } else if (typeof hora === 'number') {  
         return hora;
      }
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    request() {
      if (this.$refs.formReservation.validate()) {
        const data = {
          title: this.title,
          description: this.description,
          reservationDate: this.reservationDate,
          customerId: this.customerId,
          reservationHour: this.timePickerToNum(this.reservationHour) || 0,
          lapse: this.booking.lapse,
          partyRoomId: this.booking.id,
        };
        reservationService.create(data).then( () => {
          this.$router.push({ name: 'bookingthanks' });
        }).catch((error) => {
              if (error.response && [400, 409].includes(error.response.status)) {
                this.$swal('Error crear solicitud de reservación', error.response.data.message, 'warning');
              }
            });
      }
    },
  },
};
</script>